export const NEXT_URL_QUERY_PARAM = 'next';
